import * as constants from 'static/Constants';

export const handleFacing = (removedSpaceTypeGen) => {
  switch (removedSpaceTypeGen) {
    case 'ProductImageWeb':
    case 'ProductImageWithSupportingElementsWeb':
    case 'ProductImageHighResolution':
    case 'ProductImageWithSupportingElementsHighResolution':
    case 'OptimisedHeroImage':
      return constants.FACING_ABCDU;

    case 'ProductImage360D3D':
    case 'DetailTechnologyImage':
    case 'ContentTexture':
    case 'SamplePrototypeMockupImage':
    case 'SocialMedia':
    case 'Application':
    case 'SizeComparison':
    case 'AmbienceMood':
    case 'SidekickImage':
    case '_3DRendered':
      return constants.FACING_EFS3DR;

    case 'MobileReadyHeroImage':
      return constants.FACING_H;

    case 'MontageCompositeImage':
      return constants.FACING_M;

    case 'ProductPackagingLabelInformation':
      return constants.FACING_L;

    default:
      return constants.FACING;
  }
};

export const handleAngle = (removedSpaceTypeGen) => {
  switch (removedSpaceTypeGen) {
    case 'ProductImageWeb':
    case 'ProductImageWithSupportingElementsWeb':
    case 'ProductImageHighResolution':
    case 'ProductImageWithSupportingElementsHighResolution':
    case 'MobileReadyHeroImage':
    case 'OptimisedHeroImage':
      return constants.ANGLE_ABCDHU;

    case 'DetailTechnologyImage':
    case 'ContentTexture':
    case 'SamplePrototypeMockupImage':
    case 'SocialMedia':
    case 'Application':
    case 'SizeComparison':
    case 'AmbienceMood':
    case 'MontageCompositeImage':
      return constants.ANGLE_FM;

    case 'ProductImage360D3D':
    case 'ProductPackagingLabelInformation':
    case 'SidekickImage':
    case '_3DRendered':
      return constants.ANGLE_ELS3DR;

    default:
      return constants.ANGLE;
  }
};

export const handlePackagingDisposition = (removedSpaceTypeGen) => {
  switch (removedSpaceTypeGen) {
    case 'ProductImageWeb':
    case 'ProductImageHighResolution':
      return constants.PACKAGING_DISPOSITION_AC;

    case 'ProductImage360D3D':
    case 'DetailTechnologyImage':
    case 'ContentTexture':
    case 'SamplePrototypeMockupImage':
    case 'SocialMedia':
    case 'Application':
    case 'SizeComparison':
    case 'AmbienceMood':
    case 'MontageCompositeImage':
    case 'ProductPackagingLabelInformation':
    case 'SidekickImage':
    case '_3DRendered':
      return constants.PACKAGING_DISPOSITION_EFMLS3DR;

    case 'MobileReadyHeroImage':
      return constants.PACKAGING_DISPOSITION_H;

    default:
      return constants.PACKAGING_DISPOSITION;
  }
};

export const handleMapCompliantFileName = (compliantFileName) => {
  const compliantFileNameRegex =
    /^(\d+)_([ACDEFHLMU]|3DR|L1|_)([0-9]|10|11|12|N1|_)([CLRN]|N3|_)([01ABCDMPF_])$/;
  const match = compliantFileNameRegex.exec(compliantFileName);
  if (match) {
    const gtin = match[1];
    const imageTypeRaw = match[2];
    const facingRaw = match[3];
    const angleRaw = match[4];
    const packagingDispositionRaw = match[5];

    const imageType = constants.IMAGE_TYPE.find(
      (val) => val?.fileCode === imageTypeRaw
    );

    const removedSpaceTypeGen =
      imageType?.value && typeof imageType?.value === 'string'
        ? imageType?.value?.split(' ').join('')
        : '';

    const arrFacing = handleFacing(removedSpaceTypeGen);
    const facing = arrFacing.find((val) => val?.fileCode === facingRaw);

    const arrAngle = handleAngle(removedSpaceTypeGen);
    const angle = arrAngle.find((val) => val?.fileCode === angleRaw);

    const arrPackagingDispositionRaw = handlePackagingDisposition(removedSpaceTypeGen);
    const packagingDisposition = arrPackagingDispositionRaw.find(
      (val) => val?.fileCode === packagingDispositionRaw
    );

    return {
      gtin,
      imageType,
      facing,
      angle,
      packagingDisposition,
      isValid: true,
    };
  }
  return;
};
